import r from "./ghl-ui.es1476.js";
var a = r();
const o = a;
export {
  o as default
};
